import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { giftCategoryIdAtom } from '../atoms/giftItemAtoms';

function useGiftCategories() {
  const { data, status } = useQuery(queries.giftCategory.list());
  const { pop } = useFlow();
  const toast = useToast();
  const setGiftCategoryId = useSetAtom(giftCategoryIdAtom);
  useEffect(() => {
    if (status === 'error') {
      toast.error('선물 카테고리를 불러오지 못했습니다.');
      pop();
    }
  }, [toast, pop, status]);
  useEffect(() => {
    if (data && data.length > 0) {
      setGiftCategoryId(data[0].id);
    }
  }, [setGiftCategoryId, data]);
  return data;
}

export default useGiftCategories;
